import { getAccessToken } from './supabase.js';

const FN_CHECKOUT = import.meta.env.VITE_FN_STRIPE_CHECKOUT;
const FN_PORTAL = import.meta.env.VITE_FN_STRIPE_PORTAL;

export async function startCheckout(plan) {
  if (!FN_CHECKOUT) throw new Error('VITE_FN_STRIPE_CHECKOUT not configured');
  const token = await getAccessToken();
  if (!token) throw new Error('Not authenticated');

  const res = await fetch(FN_CHECKOUT, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'authorization': `Bearer ${token}` },
    body: JSON.stringify({ plan })
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(j?.error || `Checkout failed (${res.status})`);
  }
  const { url } = await res.json();
  if (!url) throw new Error('No checkout URL returned');
  window.location.href = url;
}

export async function openBillingPortal() {
  if (!FN_PORTAL) throw new Error('VITE_FN_STRIPE_PORTAL not configured');
  const token = await getAccessToken();
  if (!token) throw new Error('Not authenticated');

  const res = await fetch(FN_PORTAL, {
    method: 'POST',
    headers: { 'authorization': `Bearer ${token}` }
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(j?.error || `Portal failed (${res.status})`);
  }
  const { url } = await res.json();
  if (!url) throw new Error('No portal URL returned');
  window.location.href = url;
}
